export const environment = {
  environment: "staging",
  production: false,
  sentryDsn: "https://96735c7223c522557a617575b71ae6ce@o4511025266163712.ingest.de.sentry.io/4511066703855696",
  firebase: {
    apiKey: "AIzaSyC4AbpwsQmlit5wdfuF6DiZ9hOMml4P8dA",
    authDomain: "taxando-staging.firebaseapp.com",
    projectId: "taxando-staging",
    storageBucket: "taxando-staging.appspot.com",
    messagingSenderId: "738094662595",
    appId: "1:738094662595:web:246dfeef482e3ba76a3376",
    measurementId: "G-HEVM2970HE"
  },
  stripe: "pk_test_vzvCEXunPE8A9U3fwgQH3UZd00QelV3Y3Q",
  cloudflareCaptchaKey: "0x4AAAAAAACBDzi8-HQSIho6",
  googleTagManagerId: "GTM-WRHG85P",
  facebookPixelId: "626982541262181",
  etrackerSecureCode: "1Wxpgg",
  appsFlyerWebAppId: "c61fc114-bb30-4873-82c9-b93e90b123a8",
  mockYousignSignedStatus: false,
  mockPremiumPlusOffer: {
    enabled: false,
    response: null
  }
};
